export default __webpack_public_path__ + "static/navbar_logo-c531a1ddb5ba7fa2182e2dbbd519018c.svg";